import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpregistrywrite2postPostRegistryInventoriesIdBlessResponseSchema = jsonObject
export type tcpregistrywrite2postPostRegistryInventoriesIdBlessResponse = z.infer<typeof tcpregistrywrite2postPostRegistryInventoriesIdBlessResponseSchema>
export const tcpregistrywrite2postPostRegistryMaintenancePruneResponseSchema = jsonObject
export type tcpregistrywrite2postPostRegistryMaintenancePruneResponse = z.infer<typeof tcpregistrywrite2postPostRegistryMaintenancePruneResponseSchema>
export const tcpregistrywrite2postPostRegistryMaintenanceRelinkResponseSchema = jsonObject
export type tcpregistrywrite2postPostRegistryMaintenanceRelinkResponse = z.infer<typeof tcpregistrywrite2postPostRegistryMaintenanceRelinkResponseSchema>
